import React from "react";
import ReactDOM from "react-dom";
import { createMuiTheme, ThemeProvider } from "@material-ui/core/styles";
import { BrowserRouter } from "react-router-dom";
import { CssBaseline, NoSsr } from "@material-ui/core";
import { App } from "./Components/App";
import AppStateContextProvider from "./Contexts/AppStateContext";
import UserDataContextProvider from "./Contexts/UserDataContext";
import InvoiceDataContextProvider from "./Contexts/InvoiceDataContext";

const themeType = "light";
// const themeType = "dark";

const fern = "#143200";
const sand = "#EEEAD9";
const white = "#FFF";
const staging = "#F3901D";

const theme = createMuiTheme({
  palette: {
    primary: {
      main: process.env.REACT_APP_ENV === 'Staging' ? staging : fern,
      contrastText: sand,
    },
    secondary: {
      main: staging,
      contrastText: '#fff',
    },
    background: {
      default: themeType === "light" ? "#F0F0F0" : "#303030",
    },
    type: themeType,
  },
});

ReactDOM.render(
  <ThemeProvider theme={theme}>
    <CssBaseline />
    <AppStateContextProvider>
      <UserDataContextProvider>
        <InvoiceDataContextProvider>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </InvoiceDataContextProvider>
      </UserDataContextProvider>
    </AppStateContextProvider>
  </ThemeProvider>,
  document.getElementById("root")
);
